import type React from "react";
import {useNavigate, useParams} from "react-router-dom";

import {faPlay} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {useUpdateWipLevelV2, useWipLevelV2} from "~/api/hooks/useWipLevelV2";
import CustomButton from "~/component/common/CustomButton";
import {useGameState} from "~/contexts/gamestate/useGameState";

const PlayTestLevelButton: React.FC = () => {
  const {id} = useParams<{id: string}>();
  const {data: level} = useWipLevelV2({id});
  const {getAllInstances} = useGameState();
  const {mutate: updateWipLevel} = useUpdateWipLevelV2();
  const navigate = useNavigate();
  return (
    <>
      <CustomButton
        onClick={() => {
          if (!level || !id) return;
          updateWipLevel({
            key: {id},
            data: {
              ...level,
              data: getAllInstances(),
            },
          });
          navigate("test");
        }}
        aria-label="Play test level"
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
      >
        <FontAwesomeIcon
          icon={faPlay}
          size="xl"
          className="text-white p-2 -m-2 rounded-full px-2.5 bg-gradient-to-br from-orange-600 via-orange-500 to-black"
        />
      </CustomButton>
    </>
  );
};

export default PlayTestLevelButton;
